import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import {
  Page,
  Msg,
  SearchBar,
  LoadMore,
  Toast,
  Panel,
} from 'react-weui';
import PropTypes from 'prop-types';
import { formatDate } from '../lib/formatter.ts';
import Util from 'lib/util.js';
import Http from 'services/http2';
import User from 'services/user2';
import Storage from 'services/storage2';
import TopNav from 'components/topNav.js';
import ClearIcon from '@material-ui/icons/Clear';
import * as MobileActions from 'actions/index.ts';

// 供应商通知 & 客户通知

/* dev
https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxf3cf604fbe16e419&redirect_uri=http%3A%2F%2Fdev.xiekeyun.com%2Fmp%2Fnotify%2Flist%2F2&response_type=code&scope=snsapi_base&state=123#wechat_redirect
https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxf3cf604fbe16e419&redirect_uri=http%3A%2F%2Fdev.xiekeyun.com%2Fmp%2Fnotify%2Flist%2F1&response_type=code&scope=snsapi_base&state=123#wechat_redirect
*/
const Config = {
  supplierNotify: {
    title: '供应商通知',
    outboxApiPath: '/oss/compNotify/list', //发件箱
    inboxApiPath: '/oss/message/list', //收件箱
    notifyType: 2, //供应商通知
    tabs: ['发件箱', '收件箱'],
  },
  customerNotify: {
    title: '客户通知',
    outboxApiPath: '/oss/compNotify/list', //发件箱
    inboxApiPath: '/oss/message/list', //收件箱
    notifyType: 1, //客户通知
    tabs: ['发件箱', '收件箱'],
  },
};

class NotifyList extends Component {
  constructor(props) {
    super(props);
    this.reset = false;
    this.companyCode = '';
    this.pageNo = 1;
    this.searchKey = '';
    this.handleClear = this.handleClear.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleCompanyChange = this.handleCompanyChange.bind(this);
    this.toggleSearch = this.toggleSearch.bind(this);
    this.config = Config[props.type];
    this.resolveLoading = () => { }; //引用InfiniteLoader中resolveLoading方法，用于重置列表加载状态
    this.count = [];
    this.currentTab = 0; //当前页签
    this.state = {
      inited: false,
      error: null,
      dataError: null,
      list: [],
      total: 0,
      showLoading: true,
      isShowSearch: false,
      // orderStatus: this.config.tabConfig[this.currentTab],
      isOrderAutoPublish: false,
      type: 2, //1：收件箱；2：发件箱
    };
    this.isPurchase = props.type === 'supplierNotify';

    this.urlHashKey = Util.getHashKey(props.match.url);
    this.objHistoryState = Storage.getItem('historyState') || {};
    this.historyState = {};
    this.statusArr = [
      {
        status: 0,
        statusName: '草稿',
        color: '',
      },
      {
        status: 1,
        statusName: '已发送',
        color: 'green',
      },
      {
        status: 2,
        statusName: '已作废',
        color: 'red',
      },
    ];
  }

  init() {
    let paramObj = this.getRouterParams();
    //获取页面历史状态，用于详情页返回列表（页面页签等）
    this.historyState = this.objHistoryState[this.urlHashKey] || {};
    this.searchKey = this.historyState.searchKey;
    this.currentTab = this.historyState.currentTab || paramObj.currentTab || 0;
    User.init().then(response => {
      if (response.success) {
        this.setState({ inited: true });
        this.companyCode = User.getCompanyCode();
        this.getList();
      } else {
        this.setState({
          error: {
            type: 'warn',
            title: response.errorMsg,
          },
        });
      }
    });
  }

  componentDidMount() {
    this.init();
  }

  componentWillUnmount() { }

  getList(cb = () => { }) {
    let notifyType = 1;
    if (this.currentTab === 0) {
      notifyType = this.config.notifyType === 2 ? 1 : 2;
    } else {
      notifyType = this.config.notifyType;
    }
    let postbody = {
      apiPath:
        this.currentTab === 0
          ? this.config.outboxApiPath
          : this.config.inboxApiPath,
      companyCode: this.companyCode,
      pageNo: this.pageNo,
      pageSize: 10,
      searchKey: this.searchKey,
      searchType: 2,
      notifyType: notifyType,
    };
    let arrPromise = [Http.post('/api/cloudCenter', postbody)];
    this.setState({ dataError: null });
    Promise.all(arrPromise).then(arrResponse => {
      let response = arrResponse[0];
      this.reset = false;
      this.setState({ showLoading: false });
      if (response.success) {
        let data = response.data || {};
        if (Array.isArray(data.msgList)) {
          data.msgList.forEach((item, index) => {
            this.statusArr.forEach(val => {
              if (val.status === item.status) {
                item.statusName = val.statusName;
                item.color = val.color;
              }
            });
          });
        }
        this.setState(
          {
            list: this.state.list.concat(data.msgList),
            total: data.totalCount,
          },
          () => cb()
        );
        this.pageNo += 1;
      } else {
        this.setState({
          dataError: {
            type: 'warn',
            title: response.errorMsg,
          },
        });
      }
    });
  }

  getRouterParams() {
    var url = window.location.href;
    var params = url.split('?')[1];
    var paramObj = {};
    if (params) {
      var paramArr = params.split('&');
      for (var i = 0; i < paramArr.length; i++) {
        var keyValue = paramArr[i].split('=');
        var key = keyValue[0];
        var value = keyValue[1];
        if (typeof value === 'string' && isNaN(value) === false) {
          value = Number(value);
        }
        paramObj[key] = value;
      }
    }
    return paramObj;
  }

  handleCompanyChange(companyCode) {
    this.companyCode = companyCode;
    this.setState({ showLoading: true });
    this.handleReset();
  }

  handleChange(text, e) {
    e.preventDefault();
    this.searchKey = text;
    this.handleReset();
  }

  handleClear() {
    this.searchKey = '';
    this.handleReset();
  }

  handleTab(index) {
    this.currentTab = index;
    this.setState({ type: this.currentTab === 0 ? 2 : 1 });
    this.historyState.currentTab = index;
    this.handleReset();
  }

  handleReset() {
    this.reset = true;
    this.setState({
      list: [],
    });
    this.pageNo = 1;
    this.setState({ showLoading: true });
    this.getList();
    this.resolveLoading();
    // 保存搜索key
    this.historyState.searchKey = this.searchKey;
    this.objHistoryState[this.urlHashKey] = this.historyState;
    Storage.setItem('historyState', this.objHistoryState);
  }

  toggleSearch() {
    let isShowsearch = !this.state.isShowSearch;
    this.setState({ isShowSearch: isShowsearch });
  }

  search(text) {
    this.searchKey = text;
    this.setState({ showLoading: true });
    this.getList();
  }

  render() {
    //const isOrderAutoPublish = this.state.isOrderAutoPublish;
    if (this.state.error !== null) {
      return <Msg {...this.state.error} />;
    }
    return (
      <Page
        transition={false}
        ptr={false}
        onLoadMore={(resolveLoading, finish) => {
          this.resolveLoading = resolveLoading;
          if (this.state.list.length >= this.state.total) {
            finish();
          } else {
            this.getList(resolveLoading);
          }
        }}
        className="v2"
      >
        <TopNav
          inited={this.state.inited}
          onSubmit={this.handleChange}
          onCancel={this.handleClear}
          onClear={this.handleClear}
          defaultValue={this.searchKey}
          placeholder={this.config.searchBarPlaceholder}
        />
        <Panel>
          {this.state.isShowSearch && (
            <SearchBar
              onSubmit={this.handleChange}
              onCancel={this.handleClear}
              onClear={this.handleClear}
              defaultValue={this.searchKey}
              placeholder={this.config.searchBarPlaceholder}
              lang={{
                cancel: '取消',
              }}
            />
          )}

          {this.state.dataError !== null ? (
            <Msg {...this.state.dataError} />
          ) : (
            <span>
              <div className="m-tab-container">
                <ul className="m-flex-box">
                  {this.config.tabs.map((item, index) => (
                    <li
                      key={index}
                      onClick={this.handleTab.bind(this, index)}
                      className={
                        this.currentTab === index
                          ? 'm-flex-item curr'
                          : 'm-flex-item'
                      }
                    >
                      <span className="name">{item}</span>
                    </li>
                  ))}
                </ul>
                {this.searchKey && (
                  <div className="searchKeyBox">
                    查询信息：
                    <div onClick={this.handleClear}>
                      <span className="singleOmission">{this.searchKey}</span>
                      <ClearIcon
                        className="verticalMiddle"
                        color="primary"
                        fontSize="inherit"
                      />
                    </div>
                  </div>
                )}
              </div>
              <div className="list-total">{this.state.total}</div>
              <div className="m-details-item">
                <div className="details-item-content">
                  {this.state.list.map((item, index) => (
                    <Link
                      to={
                        Util.isEmpty(item.status)
                          ? `/mp/notify/detail/${this.currentTab !== 0 ? 1 : 2}/${item.receiveCompanyCode || item.companyCode
                          }/${item.id}`
                          : `/mp/notify/detail/${this.state.type}/${item.receiveCompanyCode || item.companyCode
                          }/${item.id}`
                      }
                      key={index}
                      className="content-line line-list-item"
                    >
                      <div className="line-list-item-title">
                        <span>序号{index + 1}</span>
                        <div className="more">
                          {item.readFlag === 0 && <span className="u-sign red">未读</span>}
                          <span className={'f-ml5 u-sign ' + item.color}>
                            {item.statusName}
                          </span>
                        </div>
                      </div>
                      <ul className="field-list">
                        <li>
                          <label>标题</label>
                          <div>{item.msgTitle}</div>
                        </li>
                        <li>
                          <label>优先级</label>
                          <div
                            className={item.priorityValue === 9 ? 'orange' : ''}
                          >
                            {item.priorityValue === 9 ? '重要' : '一般'}
                          </div>
                        </li>
                        <li>
                          <label>发送日期</label>
                          <div>
                            {formatDate(
                              item.publishTime || item.sendTime,
                              'YYYY-MM-DD HH:mm:ss'
                            )}
                          </div>
                        </li>
                        <li>
                          <label>发送人</label>
                          <div>{item.publishName}</div>
                        </li>
                        {this.config.notifyType === 2 && (
                          <li>
                            <label>类型</label>
                            <div>{item.compNotifyType === 2 ? '集团群发' : '普通'}</div>
                          </li>
                        )}
                      </ul>
                    </Link>
                  ))}
                  {!this.state.showLoading && this.state.list.length === 0 && (
                    <LoadMore showLine> 暂无数据</LoadMore>
                  )}
                </div></div>
            </span>
          )}
        </Panel>
        <Toast icon="loading" show={this.state.showLoading}>
          数据加载中...
        </Toast>
      </Page>
    );
  }
}

NotifyList.propTypes = {
  data: PropTypes.object.isRequired,
  actions: PropTypes.object.isRequired,
};

const mapStateToProps = state => {
  return {
    data: state.login,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(MobileActions, dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(NotifyList);
